var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditLogsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 1.16602V3.49935C8.16699 3.80877 8.28991 4.10551 8.5087 4.32431C8.72749 4.5431 9.02424 4.66602 9.33366 4.66602H11.667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 4.42563V2.33268C2.33301 2.02326 2.45592 1.72652 2.67472 1.50772C2.89351 1.28893 3.19026 1.16602 3.49967 1.16602H8.74967L11.6663 4.08268V11.666C11.6663 11.9754 11.5434 12.2722 11.3246 12.491C11.1058 12.7098 10.8091 12.8327 10.4997 12.8327H3.49676C3.29246 12.8322 3.09189 12.778 2.91509 12.6756C2.7383 12.5733 2.59149 12.4263 2.48934 12.2493L2.5 11.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08301 10.084L4.20801 9.20898",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.5C3.7165 9.5 4.5 8.7165 4.5 7.75C4.5 6.7835 3.7165 6 2.75 6C1.7835 6 1 6.7835 1 7.75C1 8.7165 1.7835 9.5 2.75 9.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLogsV2);
export default __webpack_public_path__ + "static/media/auditLogsV2.0922149d8f0706261c01df0310b1dbf9.svg";
export { ForwardRef as ReactComponent };